<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <v-row> -->
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({ name: 'Home' })"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />
        <div class="custom-title">
          {{ title }}
        </div>

        <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
          <!-- <v-alert prominent type="warning">
            El sector se encuentra cerrado por receso de verano. Podrás solicitar tus trámites desde el día 02/02
          </v-alert> -->
          <v-alert prominent type="info">
            IMPORTANTE! Los Trámites con Asterisco (*) tienen costo.
          </v-alert>
        </v-col>

        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label style="font-weight: bold;">Trámite</label>
            <v-select
              v-model="tramite"
              :items="tramites"
              item-text="text"
              item-value="value"
              label="Selecciona el trámite"
              persistent-hint
              return-object
              single-line
              style="color: white !important;"
              
            ></v-select>
          </v-col>
          <!--
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Sede del trámite</label>
            <v-select
              v-model="sede"
              :items="sedes"
              item-text="text"
              item-value="value"
              label="Selecciona la sede"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>
          -->
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <!-- Subtítulo -->
            <div class="subtitulo">¿A quién va dirigido?</div>
            <v-text-field
              v-model="person"
              :rules="personRules"
              :counter="10"
              placeholder="Nombre de Institución o Empresa"
              required
              class="input-white custom-placeholder"
              
            ></v-text-field>
          </v-col>

          <!--
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Urgencia</label>
            <v-select
              v-model="urgencia"
              :items="urgencias"
              item-text="text"
              item-value="value"
              label="Selecciona la urgencia"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </v-col>
          -->
        </v-row>

        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6">
            <v-btn
              color="success"
              elevation="7"
              large
              v-on:click="examen = true"
              @click="addTramite()"
              
              >Guardar</v-btn
            >
          </v-col>
        </v-row>
        <div>
          <br />
          <h2>
            Mis trámites
          </h2>

          <!-- Vista de tabla para pantallas grandes -->
          <v-simple-table v-if="$vuetify.breakpoint.mdAndUp">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Urgencia
                  </th>
                  <th class="text-left">
                    Estado
                  </th>
                  <th class="text-left">
                    Trámite
                  </th>
                  <th>
                    Url
                  </th>
                  <th>
                    Fecha Solicitud
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(tramiteUserData, tramitesUserKey) in tramitesUser"
                  :key="tramitesUserKey"
                >
                  <td>{{ tramiteUserData.Urgencia }}</td>
                  <td>
                    <div
                      v-if="
                        tramiteUserData.Estado == 'Cancelado' &&
                          tramiteUserData.motivo != null
                      "
                    >
                      <v-btn
                        color="primary"
                        dark
                        @click="motivoRechazoTramite(tramiteUserData.motivo)"
                      >
                        Motivo del Rechazo
                      </v-btn>
                    </div>
                    <div v-else>
                      {{ tramiteUserData.Estado }}
                    </div>
                  </td>
                  <td>
                    {{
                      tramiteUserData.tramite
                        ? tramiteUserData.tramite.nombre
                        : ""
                    }}
                  </td>
                  <td
                    v-if="
                      tramiteUserData.url &&
                        hoy >= tramiteUserData.dias_expiracion
                    "
                  >
                    <a
                      :href="tramiteUserData.url"
                      class="btn btn-success"
                      target="_blank"
                      >ver constancia</a
                    >
                  </td>
                  <td v-else></td>
                  <td>{{ tramiteUserData.FechaRegistro }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <!-- Vista de menú desplegable para pantallas pequeñas -->
          <v-container v-if="$vuetify.breakpoint.xsOnly">
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(tramiteUserData, tramitesUserKey) in tramitesUser"
                :key="tramitesUserKey"
                class="custom-panel"
              >
                <v-expansion-panel-header 
                  :style="{ 
                    backgroundColor: tramiteUserData.Estado === 'Finalizado' ? '#D3D3D3' : 
                                  tramiteUserData.Estado === 'Cancelado' ? '#FF9500' : 'inherit',
                    color: tramiteUserData.Estado === 'Cancelado' ? 'white' : 'inherit',
                    borderRadius: '5px 5px 0 0',
                    border: tramiteUserData.Estado === 'Cancelado' ? '2px solid white' : 'none'
                  }"
                >
                  {{ tramiteUserData.tramite ? tramiteUserData.tramite.nombre : 'Trámite desconocido' }}

                  <!-- Ícono condicional -->
                  <template v-slot:actions>
                    <v-icon :style="{ color: tramiteUserData.Estado === 'Cancelado' ? 'white' : '#595959' }">
                      mdi-chevron-down
                    </v-icon>
                  </template>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12">
                      <div class="panel-content">
                        <div class="panel-info">
                          <span class="panel-title">Urgencia:</span> {{ tramiteUserData.Urgencia }}
                        </div>
                        <div class="panel-info">
                          <span class="panel-title">Estado:</span> {{ tramiteUserData.Estado }}
                        </div>
                        <div class="panel-info">
                          <span class="panel-title">Fecha Solicitud:</span> {{ tramiteUserData.FechaRegistro }}
                        </div>

                        <div>
                          <v-btn
                            v-if="tramiteUserData.Estado == 'Cancelado' && tramiteUserData.motivo != null"
                            color="primary"
                            dark
                            @click="motivoRechazoTramite(tramiteUserData.motivo)"
                          >
                            Motivo del Rechazo
                          </v-btn>

                          <a
                            v-if="tramiteUserData.url && hoy >= tramiteUserData.dias_expiracion"
                            :href="tramiteUserData.url"
                            class="text-blue-500 hover:underline"
                            target="_blank"
                          >
                            Ver constancia
                          </a>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>




        </div>

      </v-col>

      <v-dialog v-model="motivoRechazo" max-width="290">
        <v-card>
          <v-card-title class="text-h5">
            Motivo del Rechazo
          </v-card-title>

          <v-card-text>
            {{ mensajeRechazo }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="motivoRechazo = false">
              Cerrar
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import moment from "moment";

export default {
  name: "MateriaCodigoClaseVideo",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    hoy: moment(new Date()).format("YYYY-MM-DD"),
    title: "Nuevo trámite",
    tramite: { text: "", value: "" },
    sede: { text: "", value: "" },
    urgencia: { text: "Normal", value: "Normal" },
    select: {},
    urgencias: [
      { text: "Normal", value: "Normal" },
      { text: "Media", value: "Media" },
      { text: "Alta", value: "Alta" },
    ],
    tramites: [],
    tramitesUser: [],
    sedes: [],
    person: "",
    personRules: [(v) => !!v || "Campo obligatorio"],
    motivoRechazo: false,
    mensajeRechazo: "",
  }),

  methods: {
    async addTramite() {
      // base de datos aceptado feedback
      let tramite = this.tramite.value;
      let sede = this.sede.value;
      let urgencia = this.urgencia.value;

      let dataSend = {
        process: tramite,
        sede: sede,
        emergency: urgencia,
        person: this.person,
      };

      let url = "alumno-tramite/store";
      await this.$API
        .post({
          url: url,
          data: dataSend,
        })
        .then(() => {
          this.loadTramites();
        });
    },
    async loadTramites() {
      let url = "alumno-tramites";
      await this.$API
        .get({
          url: url,
        })
        .then((res) => {
          this.tramitesUser = res;
        });
    },

    motivoRechazoTramite(motivo) {
      this.mensajeRechazo = motivo;
      this.motivoRechazo = true;
    },
  },

  mounted() {
    this.motivoRechazo = false;
    if (
      this.$store.getters.user.borrado == 1 ||
      this.$store.getters.user.alumno_mora == true
    ) {
      this.$router.push({
        name: "Home",
      });
    }
    console.log(this.hoy);
    this.idTest = this.$route.params.test;
    this.$API
      .get({
        url: "tramites",
        data: {},
      })
      .then((res) => {
        this.tramites = res;
      })
      .catch((err) => {
        console.log(err);
      });
    this.$API
      .get({
        url: "sedes",
        data: {},
      })
      .then((res) => {
        this.sedes = res;
      })
      .catch((err) => {
        console.log(err);
      });
    this.$API
      .get({
        url: "alumno-tramites",
      })
      .then((res) => {
        this.tramitesUser = res;
      });
  },
};
</script>
<style scoped>
.custom-title {
  color: white;
  font-size: 1.5rem;
}
::v-deep .theme--light.v-card {
    background-color: #FFFFFF;
    color: white;
    font-size: 1.2rem;
}

:v-deep .v-select__selection--comma {
    margin: 7px 4px 7px 0;
    min-height: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: white !important;
}
::v-deep .theme--light.v-select .v-select__selections {
    color: white !important;
}

::v-deep .theme--light.v-label {
    color: white !important;
}
.subtitulo {
  font-size: 16px;  /* Tamaño del subtítulo */
  font-weight: bold;
  color: #ffffff; /* Color blanco para el subtítulo */
  margin-bottom: 8px; /* Espaciado entre el subtítulo y el input */
}

:v-deep .input-white .v-input__control {
  background-color: white !important; /* Fondo blanco en el área del input */
}

:v-deep .input-white .v-text-field__slot {
  background-color: white !important; /* Fondo blanco en el área de texto */
}

.input-white input {
  color: black; /* Color del texto dentro del input */
}

::v-deep .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
    display: flex;
    flex: 1 1 auto;
    position: relative;
    background-color: white !important;
    border-radius: 5px;
}

::v-deep .theme--light.v-counter {
    color: transparent !important;
}
::v-deep .theme--light.v-input input, .theme--light.v-input textarea {
    color: rgba(0, 0, 0, 0.87) !important;
    margin-left: 10px !important;
}

::v-deep .v-icon__svg {
    height: 24px;
    width: 24px;
    fill: white !important;
}



::v-deep .theme--light.v-messages {
    color: rgb(255, 149, 0) !important;
    font-size: 17px;
    font-weight: bold;
}
.custom-panel {
  border-radius: 5px; /* Borde redondeado para todo el panel */
  overflow: hidden; /* Evita que el contenido sobresalga fuera de los bordes redondeados */
}


.panel-content {
  font-size: 0.875rem; /* Fuente más pequeña para el contenido dentro de la tarjeta */
  padding-top:20px;
}

.panel-title {
  font-weight: bold; /* Negrita para los títulos */
  margin-top: 0.5rem;
}

.panel-content div {
  margin-bottom: 0.2rem; /* Espaciado entre los elementos dentro del panel */
}

@media (max-width: 600px) {
  .custom-title {
    color: white;
    font-size: 1.7rem;
    text-align: center;
  }

  h2 {
    display: block;
    font-size: 1.5em;

    font-weight: bold;
    unicode-bidi: isolate;
    text-align: center;
  } 
}

</style>
